export class RegExPatterns {
	private static _eMailPattern = new RegExp(
		'' +
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))/
			.source +
		/@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			.source
	);

	private static _fourDigits = new RegExp(/^\d{4,}$/);

	private static _noWhiteSpaceFill = new RegExp(/.*\S.*/);

	private static _onlyDigits = new RegExp(/^\d*[.]?\d*$/);

	private static _telephoneNumber = new RegExp(/^([+]?[\d\s]{10,})$/);

	private static _onlyInteger = new RegExp(/^\d*$/);

	private static _password = new RegExp(/^(?=.*[\S])[\S]{8,}$/);

	static get eMailPattern(): RegExp {
		return this._eMailPattern;
	}

	static get fourDigitsPattern(): RegExp {
		return this._fourDigits;
	}

	static get noWhiteSpaceFillPattern(): RegExp {
		return this._noWhiteSpaceFill;
	}

	static get onlyDigitsPattern(): RegExp {
		return this._onlyDigits;
	}

	static get telephoneNumberPattern(): RegExp {
		return this._telephoneNumber;
	}

	static get onlyIntegerPattern(): RegExp {
		return this._onlyInteger;
	}

	static get passwordPattern(): RegExp {
		return this._password;
	}
}
